import Id from "models/id";
import { Platform } from "./platform";
import { ResponseBody } from "./common";

export enum MaintenanceStatus {
	Planning = 'planning',
	Maintenance = 'maintenance',
	Cancelled = 'cancelled',
	Completed = 'completed', 
}

export type MaintenanceItem = {
  id: string;
  platform: Platform | null;
  status: MaintenanceStatus;
  maintenanceBegin: string | null;
  maintenanceEnd: string | null;
  isActive: boolean;
  reason: string | null;
  lastUpdate: string;
  creationDate: string;
};

export type CurrentMaintenanceItem = Omit<MaintenanceItem, 'lastUpdate' | 'creationDate' | 'isActive'> & {
  emergency: boolean;
};

export type CurrentMaintenanceResponse = ResponseBody<CurrentMaintenanceItem>;

export type MaintenanceListResponse = ResponseBody<MaintenanceItem>;

export type MaintenanceItemAdd = {
  reason: string | null;
  platform: Platform | null;
  maintenanceBegin: string | null;
  maintenanceEnd: string | null;
}

export type MaintenanceItemEdit = Id & {
  maintenanceBegin: string | null;
  maintenanceEnd: string | null;
}

export type MaintenanceFilter = {
  platform?: string;
  page: number;
  count: number;
}


export interface MaintenanceCompletionRequest {
  platform: Platform;
}
